var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import { connect } from "react-redux";
import Loader from "../Loader.jsx";
import { EN, RU, UZ } from "../../constants/Language.js";
import JacktopGamesBanner from "./banners/jacktop-games/JacktopGamesBanner";
import VivoBanner from "./banners/vivo/VivoBanner.jsx";
SwiperCore.use([Autoplay]);
var DELAY_SECONDS = 5 * 1000;
var availablePaths = ["/"];
var formatErrorMessage = function (langType) {
    var _a;
    var localization = (_a = {},
        _a[RU] = {
            tvbetMessage: "Ошибка загрузки баннера. Повторите попытку позже",
        },
        _a[EN] = {
            tvbetMessage: "Banner loading error. Please try again later",
        },
        _a[UZ] = {
            tvbetMessage: "Banner yuklanmadi. Keyinroq qayta urinib ko'ring",
        },
        _a);
    return localization[langType] || localization[EN];
};
var SliderBanner = /** @class */ (function (_super) {
    __extends(SliderBanner, _super);
    function SliderBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeSlide: 0,
        };
        _this.handleSlideChange = function (swiper) {
            _this.setState({ activeSlide: swiper.realIndex });
        };
        return _this;
    }
    SliderBanner.prototype.componentDidUpdate = function (prevProps) {
        var languageId = this.props.languageId;
        if (prevProps.gamesTvBet && prevProps.gamesTvBet.error !== this.props.gamesTvBet.error &&
            this.props.gamesTvBet.error) {
            alert(formatErrorMessage(languageId).tvbetMessage);
        }
    };
    SliderBanner.prototype.render = function () {
        var _this = this;
        var activeSlide = this.state.activeSlide;
        var location = this.props.location;
        if (!availablePaths.includes(location.pathname))
            return null;
        var renderer = [JacktopGamesBanner, VivoBanner];
        var isOneSlide = renderer.length === 1;
        return (_jsxs(Swiper, __assign({ spaceBetween: 5, slidesPerView: 1.1, centeredSlides: true, autoplay: {
                delay: DELAY_SECONDS,
                stopOnLastSlide: !isOneSlide,
                disableOnInteraction: false,
            }, loop: !isOneSlide, allowTouchMove: !isOneSlide, speed: 500, onSlideChange: this.handleSlideChange, onSwiper: function (swiper) { return (_this.swiperRef = swiper); } }, { children: [this.props.gamesTvBet && this.props.gamesTvBet.fetching && _jsx(Loader, {}), renderer.map(function (Banner, idx) {
                    return (_jsxs(SwiperSlide, { children: [_jsx(Banner, { isActiveSlide: activeSlide === idx }, idx), !isOneSlide && (_jsx("div", { className: "promo__progress" }, "progress-".concat(idx)))] }, idx));
                })] })));
    };
    return SliderBanner;
}(Component));
export default withRouter(connect(function (state) {
    return {
        gamesTvBet: state.games.tvbet,
        languageId: state.application.get("languageId"),
    };
})(SliderBanner));



// WEBPACK FOOTER //
// ./src/components/slider-banner/SliderBanner.jsx